module.exports = __webpack_public_path__ + "img/jiliang_home_bannner.571bd96.png";